// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"93":"3db127e6","167":"44ef4729","403":"997771a0","615":"7bdc3bbc","974":"4b6f8bed"}[chunkId] + ".css";
};